<div class="map-card" [style.background-image]="'url(' + image() + ')'">
    <button class="view-btn" (click)="onNavigate($event)">
        <i class="fas fa-eye"></i>
        @if (categoria() === 'alo') {
        {{'MAP.VIEW_ACCOMMODATIONS' | translate}}
        } @else {
        {{'MAP.VIEW_SHEET' | translate}}
        }
    </button>

    <div class="card-overlay">
        <span class="card-category">{{ categoriaLabel() | translate }}</span>
        <h3 class="card-title">{{ denominacion() }}</h3>
    </div>
</div>